import * as React from 'react';
export default function LoaderComponent({
    resolutionSmall,
}: {
    resolutionSmall?: any;
}): React.JSX.Element {
    return (
        <div className="text-center p-4">
            <div
                className={`flex items-center justify-center ${resolutionSmall ? 'h-[10vh]' : 'h-[65vh]'}`}
                data-testid="loader-component"
            >
                {/* spinner */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        margin: 'auto',
                        background: 'rgb(255, 255, 255)',
                        display: 'block',
                        shapeRendering: 'auto',
                    }}
                    width={`${resolutionSmall ? '50px' : '150px'}`}
                    height={`${resolutionSmall ? '50px' : '150px'}`}
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="32"
                        strokeWidth="8"
                        stroke="#48abca"
                        strokeDasharray="50.26548245743669 50.26548245743669"
                        fill="none"
                        strokeLinecap="round"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="rotate"
                            repeatCount="indefinite"
                            dur="0.5076142131979695s"
                            keyTimes="0;1"
                            values="0 50 50;360 50 50"
                        ></animateTransform>
                    </circle>
                    {/* <!-- [ldio] generated by https://loading.io/ --> */}
                </svg>
            </div>
        </div>
    );
}
